import { Component, Input, OnInit } from "@angular/core";
import { DocumentModel } from "../shared/models/document.model";
declare var $;
import { jsPDF } from "jspdf";

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.scss"],
})
export class DocumentsComponent implements OnInit {
  @Input() documents: DocumentModel[];

  constructor() {}

  ngOnInit() {}

  downloadDocuments() {
    let doc = new jsPDF();
    for (var i = 0; i < this.documents.length; i++) {
      doc.addImage(this.documents[i].image, "JPEG", 0, 0, 200, 300);
    }
    doc.save("laboratory.pdf");
  }
}
